import { forwardRef } from 'react';
import clsx from 'clsx';
import styles from './label.module.less';

export type LabelProps = React.ComponentPropsWithoutRef<'label'>;

// props.hidden visually hides label element, but still make available for screen readers
export const Label = forwardRef<HTMLLabelElement, LabelProps>(function Label(
  { className, ...rest },
  ref
) {
  return (
    <label className={clsx(styles.label, className)} ref={ref} {...rest} />
  );
});
